// buildConsistentConfig.js
// Matches logic from AdvancedOrderPopup.handleFinalDone() CONSISTENT branch. :contentReference[oaicite:3]{index=3}

function deriveQuantityFromAmount(amountNum, avgPrice) {
    if (!avgPrice || avgPrice <= 0 || Number.isNaN(avgPrice)) return NaN;
    return Math.floor(amountNum / avgPrice);
}

function buildNonPreopenBase({
                                 side,
                                 executionMode,
                                 singleLargestOrderValue,
                                 totalDurationValue,
                                 totalDurationUnit, // MINUTES | HOURS | DAYS
                                 selectedUserId, // required for CONSISTENT/RANGE (optional in your UI), null allowed
                             }) {
    // Execution mode normalization
    const execMode = (executionMode === "RELAXED" || executionMode === "AGGRESSIVE")
        ? executionMode
        : "AGGRESSIVE";

    // RELAXED requires duration > 0
    if (execMode === "RELAXED" && (totalDurationValue === "" || Number(totalDurationValue) <= 0)) {
        return { error: "Total execution duration must be > 0 for RELAXED execution mode." };
    }

    // Single largest order value is required
    const slvParsed = parseFloat(singleLargestOrderValue);
    if (!slvParsed || Number.isNaN(slvParsed) || slvParsed <= 0) {
        return { error: "Single largest order value (₹) must be > 0." };
    }

    // Total duration (optional unless RELAXED)
    let th = null;
    if (totalDurationValue !== "") {
        const raw = parseFloat(totalDurationValue);
        if (Number.isNaN(raw) || raw <= 0) {
            return {
                error:
                    execMode === "RELAXED"
                        ? "Total execution duration must be > 0 for RELAXED execution mode."
                        : "Total execution duration must be > 0 if specified.",
            };
        }

        switch (totalDurationUnit) {
            case "MINUTES":
                th = raw / 60.0;
                break;
            case "DAYS":
                th = raw * 24.0;
                break;
            case "HOURS":
            default:
                th = raw;
                break;
        }
    }

    return {
        base: {
            side,
            executionMode: execMode,
            totalDurationHours: th,
            singleLargestOrderValue: slvParsed,
            zerodhaUserId: selectedUserId || null,
        },
    };
}

export function buildConsistentConfig({
                                          side,

                                          // UI numeric fields
                                          price,
                                          quantity,
                                          amount,
                                          lotSize,
                                          // Safeguards + exec
                                          executionMode,
                                          singleLargestOrderValue,
                                          totalDurationValue,
                                          totalDurationUnit,

                                          // user selection
                                          selectedUserId,
                                      }) {
    // base + safeguards
    const baseRes = buildNonPreopenBase({
        side,
        executionMode,
        singleLargestOrderValue,
        totalDurationValue,
        totalDurationUnit,
        selectedUserId,
    });
    if (baseRes.error) return { error: baseRes.error };

    const p = parseFloat(price);
    if (!p || p <= 0 || Number.isNaN(p)) {
        return { error: "Price must be > 0." };
    }
    const lot = Number(lotSize);
    if (!Number.isFinite(lot) || lot <= 0) {
        return { error: "Lot size is not available for this symbol. Cannot place CONSISTENT order." };
    }

    const qtyNum = parseFloat(quantity);
    const amountNum = parseFloat(amount);

    const hasQty = !Number.isNaN(qtyNum) && qtyNum > 0;
    const hasAmount = !Number.isNaN(amountNum) && amountNum > 0;

    if (hasQty && hasAmount) return { error: "Enter either quantity OR amount, not both." };
    if (!hasQty && !hasAmount) return { error: "Please enter quantity or amount." };

    let finalQty;
    if (hasQty) {
        finalQty = Math.floor(qtyNum);
    }
    else {
        const derivedQty = deriveQuantityFromAmount(amountNum, p);
        if (!Number.isFinite(derivedQty) || derivedQty <= 0) {
            return { error: "Amount is too small for the given price – quantity becomes 0." };
        }

// floor to lot multiple
        const lotAdjusted = Math.floor(derivedQty / lot) * lot;
        if (lotAdjusted < lot) {
            return { error: `Amount is too small. Minimum is 1 lot (${lot}) at the given price.` };
        }
        finalQty = lotAdjusted;

    }
    finalQty = Math.floor(Number(finalQty));

    if (!Number.isFinite(finalQty) || finalQty <= 0) {
        return { error: "Expected quantity must be > 0." };
    }
    if (finalQty < lot) {
        return { error: `Expected quantity must be at least 1 lot (${lot}).` };
    }
    if (finalQty % lot !== 0) {
        return { error: `Expected quantity must be a multiple of lot size (${lot}).` };
    }

    return {
        config: {
            ...baseRes.base,
            mode: "CONSISTENT",
            targetPrice: p,
            expectedQuantity: finalQty,
            lotSize: lot,
        },
        shouldAutoClose: true,
    };
}
